<template>
  <div class="header_search_container">
    <div class="main_search_container">
      <a-form layout="inline"
              labelAlign="left"
              class="basic_search_container">
        <a-form-item label="订单编号">
          <a-input placeholder="输入产品订单号"
                   v-model="search.sn" />
        </a-form-item>
        <a-form-item label="订单状态">
          <a-select v-model="search.status" style="width: 100px">
            <a-select-option v-for="item in orderStatusList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
          </a-select>
        </a-form-item>
<!--        <a-form-item label="订单类型">-->
<!--          <a-select v-model="search.orderType">-->
<!--            <a-select-option v-for="type in orderTypeList"-->
<!--                             :key="type.value"-->
<!--                             :value="type.value">{{type.title}}</a-select-option>-->
<!--          </a-select>-->
<!--        </a-form-item>-->

      </a-form>
      <div class="btn_container">
        <span class="btn_item">
          <a-button type="primary"
                    block
                    @click="searchOrderList">搜索</a-button>
        </span>
<!--        <span class="ml20 btn_item"-->
<!--              @click="showMoreSearch">-->
<!--          <a-button block>高级搜索-->
<!--            <a-icon :type="isShowMoreSearch ? 'up':'down'" />-->
<!--          </a-button>-->
<!--        </span>-->
      </div>
    </div>
    <transition name="slide-fade">
      <a-form-model layout="inline"
                    :model="search"
                    ref="moreSearchForm"
                    labelAlign="left"
                    class="more_search_container"
                    v-show="isShowMoreSearch">
        <a-form-model-item label="商品名称">
          <a-input v-model="search.goodsName" placeholder="请输入商品名称" />
        </a-form-model-item>
        <a-form-model-item label="收货人姓名">
          <a-input v-model="search.recName"  placeholder="请输入收货人姓名"/>
        </a-form-model-item>
        <a-form-model-item label="下单时间">
          <a-range-picker separator="-"
                          @change="changeOrderTime" />
        </a-form-model-item>
        <a-form-model-item label="收货人电话"
                           prop="recTel">
          <a-input v-model="search.recTel" placeholder="请输入收货人电话"/>
        </a-form-model-item>
        <a-form-model-item label="买家备注">
          <a-input v-model="search.buyerRemark" placeholder="请输入买家备注"/>
        </a-form-model-item>
        <a-form-model-item label="商家店铺名">
          <a-input v-model="search.storeName" placeholder="请输入商家店铺名"/>
        </a-form-model-item>
        <a-form-model-item label="快递单号"
                           v-if="isShowShippingCode">
          <a-input v-model="search.shippingCode" placeholder="请输入快递单号"/>
        </a-form-model-item>
        <a-form-model-item label="是否补差价">
          <a-radio-group v-model="search.isDiff">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'OrderSearch',
  props: {
    isShowShippingCode: {
      type: Boolean,
      required: false,
      default: true
    },
    status: {
      required: false
    }
  },
  data () {
    return {
      isShowMoreSearch: false,
      orderTypeList: [
        {
          title: '全部订单',
          value: ''
        },
        {
          title: '库存订单',
          value: '1'
        },
        {
          title: '拼多多订单',
          value: '2'
        },
        {
          title: '非拼多多订单',
          value: '3'
        },
        {
          title: '仓库自提',
          value: '4'
        }
      ],
      orderStatusList: [
        {
          id:666,
          name:'全部'
        },
        {
          id:1,
          name:'待审核'
        },
        {
          id:2,
          name:'待付款'
        },
        {
          id:3,
          name:'待发货'
        },
        {
          id:4,
          name:'已发货'
        },
        {
          id:5,
          name:'异常'
        },
        {
          id:0,
          name:'已作废'
        }
      ],
      search: {
        sn: '',
        orderType: '',
        goodsName: '',
        recName: '',
        recTel: '',
        startTime: '',
        endTime: '',
        buyerRemark: '',
        storeName: '',
        shippingCode: '',
        isDiff: '0',
        status: 666
      }
    }
  },
  created () {
    if (this.isShowShippingCode) this.search.shippingCode = ''
  },
  methods: {
    resetSearch () {
      this.$refs.moreSearchForm.resetFields()
      this.search = {
        sn: '',
        orderType: '',
        goodsName: '',
        recName: '',
        recTel: '',
        startTime: '',
        endTime: '',
        buyerRemark: '',
        storeName: '',
        shippingCode: '', // 快递编号
        isDiff: 0,
      }
      this.isShowMoreSearch = false
    },
    showMoreSearch () {
      this.isShowMoreSearch = !this.isShowMoreSearch
    },
    changeOrderTime ([start, end]) {
      this.search.startTime = start.format('YYYY-MM-DD')
      this.search.endTime = end.format('YYYY-MM-DD')
    },
    searchOrderList () {
      if (this.isShowMoreSearch) {
        this.$refs.moreSearchForm.validate(status => {
          if (!status) return
          this.$emit('search', this.search)
        })
      } else {
        let { sn,status } = this.search
        this.$emit('search', { sn, status })
      }

    }
  },
  watch: {
    status () {
      this.resetSearch()
    }
  }
}
</script>

<style scoped>
.mr8 {
  margin-right: 8px;
}
.header_search_container {
  width: 100%;
  min-height: 72px;
  background: #ffffff;
  padding: 0 10px;
  box-sizing: border-box;
}

.main_search_container {
  min-height: 72px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  padding: 0 20px;
}

.basic_search_container {
  height: 72px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0;
}

.more_search_container {
  max-width: 900px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px 20px 30px;
}

.header_search_container >>> .ant-form-item-label {
  width: 90px;
  font-size: 14px;
}
.header_search_container
  >>> .ant-form-inline
  .ant-form-item
  > .ant-form-item-control-wrapper {
  width: 250px;
}

.header_search_container >>> .ant-form-inline .ant-form-item {
  margin-right: 80px;
}
.btn_container {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0;
}
.btn_item {
  display: inline-block;
  min-width: 86px;
  height: 30px;
}
.ml20 {
  margin-left: 20px;
}
</style>
No search results.



// WEBPACK FOOTER //
// src/components/Platform/OrderSearch.vue